<template>
  <div>
    <div id="myChart" :style="{width: '100%', height: '320px'}"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
     let option = {
           tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
        grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
     legend: {
        data: ['2011年', '2012年']
    },
    xAxis: {
        type: 'category',
          data: ['周一','周二','周三','周四','周五','周六','周日']
    },
    yAxis: {
        type: 'value'
    },
   series: [
        {
            name: '2011年',
            type: 'bar',
            data: [18203, 23489, 29034, 104970, 131744, 630230]
        },
        {
            name: '2012年',
            type: 'bar',
            data: [19325, 23438, 31000, 121594, 134141, 681807]
        }
    ]
};

      myChart.setOption(option);
    }
  }
};
</script>

<style scoped lang="less">
</style>
